import { render, staticRenderFns } from "./InvoiceStepEmailSettings.vue?vue&type=template&id=b024afc8&"
import script from "./InvoiceStepEmailSettings.vue?vue&type=script&lang=js&"
export * from "./InvoiceStepEmailSettings.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceStepEmailSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports